<script>
  import DateTimePickerLocal from '@/_legacy/components/DateTimePickerLocal.vue';

  export default {
    name: 'ConductInspectionItemQuestionDateTime',
    components: {
      DateTimePickerLocal,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      valueChanged(value) {
        this.$emit('change', {
          uuid: this.item.uuid,
          response: value,
          responded: !!value,
        });
      },
    },
  };
</script>

<template>
  <DateTimePickerLocal
    ref="datepicker"
    class="w-full"
    :value="this.item.response"
    :enable-date="item.params.date"
    :enable-time="item.params.time"
    @change="valueChanged"
  />
</template>
